import type { ReflectionElementValue } from '@vedalib/editor/lib/elements';
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './ReflectionElement'
import * as s from './ReflectionElement.module.scss'
import type { ReflectionDemoType } from './reflectionTypes'

const DEMO_VALUE: ReflectionElementValue = {
  displayDownloadButton: true,
}

const ReflectionDemo: ReflectionDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <div className={s.demo}>
      <Element
        element={{
          id: `${CONFIG_ELEMENTS.reflection.type}-demo`,
          type: CONFIG_ELEMENTS.reflection.type,
          value: DEMO_VALUE,
          style: {},
          font: {},
          feedback: {},
        }}
        feedback={feedback}
        font={fonts}
        mode={DEMO_MODE}
        styles={styles}
      />
    </div>
  </DemoWrapper>
)

export default ReflectionDemo
